<template>
  <m-base
    :title="params.title"
    :subTitle="params.subTitle"
    :showMore="params.showMore"
    :icon="params.icon"
    :showIcon="params.showIcon"
    :boxType="pattern.boxType"
    :showHeader="params.showHeader"
    :showBorderRadius="pattern.showBorderRadius"
    :showTopBorder="pattern.showTopBorder"
    :showRightBorder="pattern.showRightBorder"
    :showBottomBorder="pattern.showBottomBorder"
    :showLeftBorder="pattern.showLeftBorder"
    :showTopPadding="pattern.showTopPadding"
    :showRightPadding="pattern.showRightPadding"
    :showBottomPadding="pattern.showBottomPadding"
    :showLeftPadding="pattern.showLeftPadding"
    :backgroundColor="pattern.backgroundColor"
    @onClickMore="onClickMore"
  >
    <div slot="content" class="m-box-pro-content">
      <!-- 1行1列 -->
      <div
        v-if="pattern.layoutType == '1row1column'"
        v-for="(item,index) in myData.list"
        :key="index"
        class="m-box-pro-content-item d-flex flex-row"
        :class="{'box-radius':pattern.itemShowBorderRadius,'box-block':pattern.itemBoxType == 'block','box-card':pattern.itemBoxType == 'card'}"
        :style="{backgroundColor:pattern.itemBackgroundColor}"
        @click="onClickitem(item,index)"
      >
        <van-image lazy-load
          class="picture1"
          :src="showText('src',item)"
          :class="{'box-radius':pattern.itemImgShowBorderRadius}"
        ></van-image>
        <div class="flex-1 d-flex flex-column" style="padding:5px">
          <span class="title">{{showText('title',item)}}</span>
          <span class="subTitle flex-1">{{showText('subTitle',item)}}</span>
          <div class="d-flex flex-row justify-content-between align-items-end">
            <span class="desc">{{showText('desc',item)}}</span>
            <span class="desc2">{{showText('desc2',item)}}</span>
          </div>
        </div>
      </div>
      <!-- 1行2列 -->
      <div
        v-if="pattern.layoutType == '1row2column'&&index%2==0"
        v-for="(item,index) in myData.list"
        :key="index"
        class="d-flex flex-row"
      >
        <div
          class="m-box-pro-content-item d-flex flex-column flex-1"
          @click="onClickitem(item,index)"
          :class="{'box-radius':pattern.itemShowBorderRadius,'box-block':pattern.itemBoxType == 'block','box-card':pattern.itemBoxType == 'card'}"
          :style="{backgroundColor:pattern.itemBackgroundColor}"
        >
          <van-image lazy-load
            class="picture2"
            :class="{'box-radius':pattern.itemImgShowBorderRadius}"
            :src="showText('src',item)"
          ></van-image>
          <div class="flex-1 d-flex flex-column" style="padding:5px">
            <span class="title flex-1">{{showText('title',item)}}</span>
            <div class="d-flex flex-row justify-content-between align-items-end">
              <span class="desc">{{showText('desc',item)}}</span>
              <span class="desc2">{{showText('desc2',item)}}</span>
            </div>
          </div>
        </div>
        <div v-if="myData.list.length-index>1" class="centerBorder"></div>
        <div
          v-if="myData.list.length-index>1"
          class="m-box-pro-content-item d-flex flex-column flex-1"
          @click="onClickitem(myData.list[index+1],index)"
          :class="{'box-radius':pattern.itemShowBorderRadius,'box-block':pattern.itemBoxType == 'block','box-card':pattern.itemBoxType == 'card'}"
          :style="{backgroundColor:pattern.itemBackgroundColor}"
        >
          <van-image lazy-load
            class="picture2"
            :src="showText('src',myData.list[index+1])"
            :class="{'box-radius':pattern.itemImgShowBorderRadius}"
          ></van-image>
          <div class="flex-1 d-flex flex-column" style="padding:5px">
            <span class="title flex-1">{{showText('title',myData.list[index+1])}}</span>
            <div class="d-flex flex-row justify-content-between align-items-end">
              <span class="desc">{{showText('desc',myData.list[index+1])}}</span>
              <span class="desc2">{{showText('desc2',myData.list[index+1])}}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 1行多列 -->
      <div v-if="pattern.layoutType == '1rowNcolumn'" class="box-section-scroll">
        <div
          v-for="(item,index) in myData.list"
          :key="index"
          :style="{
            width: (100 / 2.5 )+'%' ,
            marginRight:myData.list.length-index>1?'10px':'0px',
            display:'inline-block'}"
        >
          <div class="d-flex flex-row">
            <div
              @click="onClickitem(item,index)"
              class="m-box-pro-content-item d-flex flex-column flex-1"
              :class="{'box-radius':pattern.itemShowBorderRadius,'box-block':pattern.itemBoxType == 'block','box-card':pattern.itemBoxType == 'card'}"
              :style="{
              backgroundColor:pattern.itemBackgroundColor,
            }"
            >
              <van-image lazy-load
                class="picture2 zheight"
                :class="{'box-radius':pattern.itemImgShowBorderRadius}"
                :src="showText('src',item)"
              ></van-image>
              <div class="flex-1 d-flex flex-column" style="padding:5px">
                <span class="title flex-1">{{showText('title',item)}}</span>
                <div class="d-flex flex-row justify-content-between align-items-end">
                  <span class="desc">{{showText('desc',item)}}</span>
                  <span class="desc2">{{showText('desc2',item)}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </m-base>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => {
        return {
          title: '热销商品',
          subTitle: 'Hot Sales',
          showMore: true,
          icon: '/static/temp/h1.png',
          showIcon: true
        }
      }
    },
    data: {
      type: Object,
      default: () => {
        return {
          type: 'product',
          maxLength: 10,
          list: []
        }
      }
    },
    pattern: {
      type: Object,
      default: () => {
        return {
          boxType: 'block',
          showTopBorder: false,
          showRightBorder: false,
          showBottomBorder: true,
          showLeftBorder: false,
          showTopPadding: true,
          showRightPadding: true,
          showBottomPadding: true,
          showLeftPadding: true,
          showHeader: true,
          showBorderRadius: false,
          backgroundColor: 'rgba(255,255,255,1)',
          //排列方式 1row2column 一行两列，1row1column 一行一列
          layoutType: '1row2column',
          itemBackgroundColor: 'rgba(255,255,255,1)',
          itemShowBorderRadius: false,
          itemImgShowBorderRadius: false,
          itemBoxType: 'block'
        }
      }
    },
    type: {
      type: String,
      default: 'default'
    }
  },
  data () {
    return {
      myData: JSON.parse(JSON.stringify(this.data)),
      //数据解析器
      formats: {
        product: {
          //数据获取
          getDataFunc: () => {
            this.$http.request(this.$http.pathMap.wxProductList, 'get', { page: 1, size: !!this.data.maxLength ? this.data.maxLength : 10 }).then(res => {
              let data = res.data
              this.myData.list = data.list
            })
          },
          refreshDataFunc: () => {
            let ids = []
            this.myData.list.forEach(li => {
              if (li.id) {
                ids.push(li.id)
              }
            });
            this.$http.request(this.$http.pathMap.refreshWxProductList, 'post', ids).then(res => {
              let data = res.data
              if (data.length == this.myData.list.length) {
                this.myData.list = data
              }
            })
          },
          //数据字段转换和格式化
          dataSwitch: {
            src: {
              key: 'picture',
              format: this.defaultSrcFormat
            },
            title: {
              key: 'name',
              format: this.defaultFormat
            },
            subTitle: {
              key: 'subName',
              format: this.defaultFormat
            },
            desc: {
              key: 'price',
              format: (text) => {
                return '¥' + text
              }
            },
            desc2: {
              key: 'scanNum',
              format: (text) => {
                let t = (text >= 10000 ? (text / 10000).toFixed(2) + '万' : text) + '人浏览'
                return t
              }
            },
          },
          detailRouter: (data) => {
            console.log(data)
            return {
              path: '/pages/product/product',
              query: {
                type:1,
                id: data.id
              }
            }
          },
          moreRouter: () => {
            return '/pages/category/category';
          }
        },
        video: {
          getDataFunc: () => {
            this.$http.request(this.$http.pathMap.wxCourseList, 'get', { page: 1, size: !!this.data.maxLength ? this.data.maxLength : 10, type: 1 }).then(res => {
              let data = res.data
              this.myData.list = data.list
            })
          },
          refreshDataFunc: () => {
            let ids = []
            this.myData.list.forEach(li => {
              if (li.id) {
                ids.push(li.id)
              }
            });
            this.$http.request(this.$http.pathMap.refreshWxCourseList, 'post', { ids, type: 1 }).then(res => {
              let data = res.data
              if (data.length == this.myData.list.length) {
                this.myData.list = data
              }
            })
          },
          //数据字段转换和格式化
          dataSwitch: {
            src: {
              key: 'picture',
              format: this.defaultSrcFormat
            },
            title: {
              key: 'name',
              format: this.defaultFormat
            },
            subTitle: {
              key: 'teacherName',
              format: this.defaultFormat
            },
            desc: {
              key: 'price',
              format: (text) => {
                return '¥' + text
              }
            },
            desc2: {
              key: 'scanNum',
              format: (text) => {
                let t = (text >= 10000 ? (text / 10000).toFixed(2) + '万' : text) + '人浏览'
                return t
              }
            },
          },
          detailRouter: (data) => {
            return {
              path: '/onlinePages/course/course',
              query: {
                id: data.id
              }
            }
          },
          moreRouter: () => {
            return '/onlinePages/category/category';
          }
        },
        audio: {
          getDataFunc: () => {
            this.$http.request(this.$http.pathMap.wxCourseList, 'get', { page: 1, size: !!this.data.maxLength ? this.data.maxLength : 10, type: 2 }).then(res => {
              let data = res.data
              this.myData.list = data.list
            })
          },
          refreshDataFunc: () => {
            let ids = []
            this.myData.list.forEach(li => {
              if (li.id) {
                ids.push(li.id)
              }
            });
            this.$http.request(this.$http.pathMap.refreshWxCourseList, 'post', { ids, type: 2 }).then(res => {
              let data = res.data
              if (data.length == this.myData.list.length) {
                this.myData.list = data
              }
            })
          },
          //数据字段转换和格式化
          dataSwitch: {
            src: {
              key: 'picture',
              format: this.defaultSrcFormat
            },
            title: {
              key: 'name',
              format: this.defaultFormat
            },
            subTitle: {
              key: 'teacherName',
              format: this.defaultFormat
            },
            desc: {
              key: 'price',
              format: (text) => {
                return '¥' + text
              }
            },
            desc2: {
              key: 'scanNum',
              format: (text) => {
                let t = (text >= 10000 ? (text / 10000).toFixed(2) + '万' : text) + '人浏览'
                return t
              }
            },
          },
          detailRouter: (data) => {
            return {
              path: '/onlinePages/course/course',
              query: {
                id: data.id
              }
            }
          },
          moreRouter: () => {
            return '/onlinePages/category/category';
          }
        },
        image: {
          getDataFunc: () => {
            this.$http.request(this.$http.pathMap.wxCourseList, 'get', { page: 1, size: !!this.data.maxLength ? this.data.maxLength : 10, type: 3 }).then(res => {
              let data = res.data
              this.myData.list = data.list
            })
          },
          refreshDataFunc: () => {
            let ids = []
            this.myData.list.forEach(li => {
              if (li.id) {
                ids.push(li.id)
              }
            });
            this.$http.request(this.$http.pathMap.refreshWxCourseList, 'post', { ids, type: 3 }).then(res => {
              let data = res.data
              if (data.length == this.myData.list.length) {
                this.myData.list = data
              }
            })
          },
          //数据字段转换和格式化
          dataSwitch: {
            src: {
              key: 'picture',
              format: this.defaultSrcFormat
            },
            title: {
              key: 'name',
              format: this.defaultFormat
            },
            subTitle: {
              key: 'teacherName',
              format: this.defaultFormat
            },
            desc: {
              key: 'price',
              format: (text) => {
                return '¥' + text
              }
            },
            desc2: {
              key: 'scanNum',
              format: (text) => {
                let t = (text >= 10000 ? (text / 10000).toFixed(2) + '万' : text) + '人浏览'
                return t
              }
            },
          },
          detailRouter: (data) => {
            return {
              path: '/onlinePages/course/course',
              query: {
                id: data.id
              }
            }
          },
          moreRouter: () => {
            return '/onlinePages/category/category';
          }
        },
        live: {
          getDataFunc: () => {
            this.$http.request(this.$http.pathMap.wxLiveList, 'get', { page: 1, size: !!this.data.maxLength ? this.data.maxLength : 10 }).then(res => {
              let data = res.data
              this.myData.list = data.list
            })
          },
          refreshDataFunc: () => {
            let ids = []
            this.myData.list.forEach(li => {
              if (li.id) {
                ids.push(li.id)
              }
            });
            this.$http.request(this.$http.pathMap.refreshWxLiveList, 'post', ids).then(res => {
              let data = res.data
              if (data.length == this.myData.list.length) {
                this.myData.list = data
              }
            })
          },
          //数据字段转换和格式化
          dataSwitch: {
            src: {
              key: 'cover',
              format: this.defaultSrcFormat
            },
            title: {
              key: 'name',
              format: this.defaultFormat
            },
            subTitle: {
              key: 'startTime',
              format: (text) => {
                return this.$uitl.formatTime('mm-dd HH:MM', new Date(text))
              }
            },
            desc: {
              key: 'price',
              format: (text, item) => {
                let str = item.type == 1 ? '免费' : item.type == 2 ? '¥' + text : item.type == 3 ? '加密' : ''
                return str
              }
            },
            desc2: {
              key: 'isLiveRecord',
              format: (text) => {
                let str = text ? '回放' : '结束'
                return str
              }
            },
          },
          detailRouter: (data) => {
            return {
              path: '/onlinePages/live/live',
              query: {
                id: data.id
              }
            }
          },
          moreRouter: () => {
            return '/onlinePages/live/list';
          }
        },
      },
    };
  },
  created () {
    this.refreshData()
  },
  methods: {
    //数据展示
    showText (key, item, index) {
      let text = this.formats[this.data.type].dataSwitch[key].format(item[this.formats[this.data.type].dataSwitch[key].key], item)
      return text
    },
    //默认的数据格式化
    defaultFormat (text) {
      return text
    },
    defaultSrcFormat (text) {
      let type = this.$getType(text)
      if (type == '[object Array]') {
        return text.length > 0 ? text[0] : ''
      } else if (type == '[object String]') {
        try {
          let texts = JSON.parse(text)
          return texts.length > 0 ? texts[0] : ''
        } catch{
          return text
        }
      }
      return ''
    },
    onClickMore () {
      this.$router.push(this.formats[this.data.type].moreRouter())
    },
    onClickitem (item, index) {
      this.$router.push(this.formats[this.data.type].detailRouter(item))
    },
    refreshData () {
      if (this.data.list.length == 0) {
        this.formats[this.data.type].getDataFunc()
      } else {
        if (this.type == 'default') {
          this.formats[this.data.type].refreshDataFunc()
        }
      }
    },
    warchRefreshData () {
      if (this.data.list.length == 0) {
        this.formats[this.data.type].getDataFunc()
      }
    }
  },
  watch: {
    data: {
      deep: true,
      handler: function (newVal, oldVal) {
        let myDataStr = JSON.stringify(oldVal)
        let newValStr = JSON.stringify(newVal)
        if (myDataStr != newValStr) {
          this.myData = JSON.parse(JSON.stringify(newVal))
          this.refreshData()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.m-box-pro-content {
}

.m-box-pro-content-item {
  margin-top: 10px;
  margin-bottom: 10px;
}

.centerBorder {
  width: 10px;
}

.picture1 {
  height: 110px;
  width: 110px;
  margin-right: 15px;
}

.picture2 {
  width: 100%;
  // height: 155px;
  margin-bottom: 5px;
}
.zheight {
  height: 155px;
}
.picture3 {
  height: inherit;
}
.title {
  font-size: $uni-font-size-lg;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.subTitle {
  font-size: $uni-font-size-base;
  color: $uni-text-color-grey;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.box-radius {
  border-radius: 12px;
  overflow: hidden;
}
.box-block {
}
.box-card {
  // padding: 24upx;
  margin: 12px 0px 2px 0px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2);
  overflow: hidden;
}
.box-section-flex-row {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}
.box-section-scroll {
  white-space: nowrap;
  overflow-x: scroll;
  overflow-y: hidden;

}
.box-section-scroll::-webkit-scrollbar {display: none; /* Chrome Safari */}

.desc {
  font-size: $uni-font-size-lg;
  color: var(--theme-font-color);
}

.desc2 {
  font-size: $uni-font-size-sm;
}
</style>
